import { matchPath, useLocation } from 'react-router'

import { useCompanyDashboardSidebarLinkTitles } from '@/hooks/useCompanyDashboardSidebarLinkTitles'
import { CLIENT_DASHBOARD_SIDEBAR_LINKS } from '@/lib/constants'
import { matchesPaths } from '@/lib/helpers/routeHelpers'
import { ROUTES } from '@/lib/routes'

export function useIsSidebarLinkActive() {
  const companyDashboardSidebarLinkTitles =
    useCompanyDashboardSidebarLinkTitles()
  const { pathname: currentRoute } = useLocation()

  return function ({ title, href }: { title: string; href: string }) {
    switch (title) {
      case companyDashboardSidebarLinkTitles.compass:
        return matchesPaths(currentRoute, [
          ROUTES._companyCompassAdmin,
          ROUTES._companyCompassDashboard,
          ROUTES._companyCompassSnapshots,
          ROUTES._companyCompassGlobalLink,
        ])

      case companyDashboardSidebarLinkTitles.referrals:
        return matchesPaths(currentRoute, [
          ROUTES._referrals,
          ROUTES._referralSummary,
        ])

      case companyDashboardSidebarLinkTitles.recommendations:
        return matchesPaths(currentRoute, [ROUTES._recommendations])

      case CLIENT_DASHBOARD_SIDEBAR_LINKS.yourSnapshots:
        return matchesPaths(currentRoute, [
          ROUTES._compassSnapshots,
          ROUTES._compassStart,
        ])

      case companyDashboardSidebarLinkTitles.yourNetwork:
        return matchesPaths(currentRoute, [
          ROUTES._professionalNetworkRelationships,
          ROUTES._professionalNetworkInvite,
          ROUTES._professionalNetworkStats,
          ROUTES._professionalNetworkRevenue,
          ROUTES._professionalNetworkApprovalManagement,
          ROUTES._professionalNetworkApprovalRequests,
          ROUTES._professionalNetworkOnboarding,
          ROUTES._addRelationship,
        ])

      default:
        // `end: false` also matches nested pages (e.g. `/clients/123` is
        // considered active for the `/clients` link).
        return !!matchPath({ path: href, end: false }, currentRoute)
    }
  }
}
